module.exports = __webpack_public_path__ + "img/5.470c9c09.svg";